import React, { useState } from 'react';
import PropTypes from 'prop-types';
import transactionService from '../services/transactionService';
import { useToast } from '../contexts/ToastContext';
import Icon from './Icon';

const TransactionSearch = ({ onResults }) => {
  const { showToast } = useToast();
  const [filters, setFilters] = useState({
    type: '',
    category: '',
    startDate: '',
    endDate: '',
    minAmount: '',
    maxAmount: '',
    description: ''
  });
  const [isSearching, setIsSearching] = useState(false);

  const categories = {
    expense: ['식비', '주거비', '교통비', '통신비', '공과금', '쇼핑', '생활용품', '뷰티/미용', '여행/레저', '문화생활', '의료/약국', '교육/강의', '경조사비', '반려동물', '금융/투자', '기타'],
    income: ['급여', '부업', '투자수익', '용돈', '상여금', '기타']
  };

  const handleSearch = async () => {
    setIsSearching(true);
    try {
      const params = {};
      Object.keys(filters).forEach(key => {
        if (filters[key]) {
          params[key] = filters[key];
        }
      });

      const data = await transactionService.searchTransactions(params);
      onResults(data);
    } catch (error) {
      showToast({ type: 'error', message: '검색에 실패했습니다.' });
    } finally {
      setIsSearching(false);
    }
  };

  const handleReset = () => {
    setFilters({
      type: '',
      category: '',
      startDate: '',
      endDate: '',
      minAmount: '',
      maxAmount: '',
      description: ''
    });
    onResults(null);
  };

  return (
    <div className="card">
      <div className="flex-between mb-16">
        <div className="flex-center gap-8">
          <Icon name="search" size={24} />
          <h3 className="card-title">거래 검색</h3>
        </div>
      </div>

      <div className="section-gap">
        <div className="grid-2">
          <div className="form-group">
            <label>유형</label>
            <select
              value={filters.type}
              onChange={(e) => setFilters({...filters, type: e.target.value, category: ''})}
            >
              <option value="">전체</option>
              <option value="income">수입</option>
              <option value="expense">지출</option>
            </select>
          </div>

          <div className="form-group">
            <label>카테고리</label>
            <select
              value={filters.category}
              onChange={(e) => setFilters({...filters, category: e.target.value})}
            >
              <option value="">전체</option>
              {filters.type && categories[filters.type]?.map(cat => (
                <option key={cat} value={cat}>{cat}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="grid-2">
          <div className="form-group">
            <label>시작 날짜</label>
            <input
              type="date"
              value={filters.startDate}
              onChange={(e) => setFilters({...filters, startDate: e.target.value})}
            />
          </div>

          <div className="form-group">
            <label>종료 날짜</label>
            <input
              type="date"
              value={filters.endDate}
              onChange={(e) => setFilters({...filters, endDate: e.target.value})}
            />
          </div>
        </div>

        <div className="grid-2">
          <div className="form-group">
            <label>최소 금액</label>
            <input
              type="number"
              value={filters.minAmount}
              onChange={(e) => setFilters({...filters, minAmount: e.target.value})}
              placeholder="0"
            />
          </div>

          <div className="form-group">
            <label>최대 금액</label>
            <input
              type="number"
              value={filters.maxAmount}
              onChange={(e) => setFilters({...filters, maxAmount: e.target.value})}
              placeholder="1,000,000"
            />
          </div>
        </div>

        <div className="form-group">
          <label>설명/메모 검색</label>
          <input
            type="text"
            value={filters.description}
            onChange={(e) => setFilters({...filters, description: e.target.value})}
            placeholder="설명이나 메모에서 검색..."
          />
        </div>

        <div className="flex-between gap-8">
          <button
            className="btn-primary btn-full-width"
            onClick={handleSearch}
            disabled={isSearching}
          >
            {isSearching ? '검색 중...' : '검색'}
          </button>
          <button
            className="btn-secondary"
            onClick={handleReset}
          >
            초기화
          </button>
        </div>
      </div>
    </div>
  );
};

TransactionSearch.propTypes = {
  onResults: PropTypes.func.isRequired,
};

export default TransactionSearch;
